import 'bootstrap';

import $ from 'jquery'; // Import jQuery
// // Ensure jQuery is globally available
import 'slick-carousel/slick/slick.css'; // Slick styles
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel'; // Import Slick


window.$ = $;
window.jQuery = $;

$(document).ready(function () {
  $('[data-bs-toggle="tooltip"]').tooltip();
  $('[data-bs-toggle="popover"]').popover();
  $('.carousel').carousel();
});




// jQuery(function($) {

	$('a.read-more').on("click", function() {
	  $(this).prev('.post-content').children('.hidden-content').slideToggle('fast', function() {
		if ($(this).is(':visible')) {
				 $(this).parent().next('a.read-more').html('<span>Read less</span>');
			} else {
				 $(this).parent().next('a.read-more').html('Read more');
			}
	  });
	});
  
	$('a#shareprint').on("click",function() {
	  if($(this).parent('.share').hasClass('active')) {
		$(this).parent('.share').removeClass('active');
	  } else {
		$(this).parent('.share').addClass('active');
	  }
	});
  
	$('.tab-holder li a').on("click", function() {
	  var tabid = $(this).attr('id');
	  var target = "#"+tabid+"-info";
	  $('.tab').hide();
	  $('.tab-holder li a').removeClass('active');
	  $(this).addClass('active');
	  $(target).show();
	});
  
	$('img.search-btn').on('click', function() {
	  $('#searchbar').slideToggle('fast', function() {
	  });
	});
  
  
// 	  /**
// 	   * Equalise
// 	   */
// 	  var $equalise = $('.equalise');
  
// 	  function equalise($items) {
// 		  if($(window).width() > 992) {
// 			  var highest = 0;
// 			  $items.each(function(i, el) {
// 				  el.style.height = 'auto';
// 				  var el_height = $(el).height();
// 				  if(el_height > highest) {
// 					  highest = el_height;
// 				  }
// 			  });
// 			  $items.each(function(i, el) {
// 				  el.style.height = (highest+'px');
// 			  });
// 		  } else {
// 			  $items.each(function(i, el) {
// 				  el.style.height = 'auto';
// 			  });
// 		  }
// 	  }
  
// 	  var $awardise = $('.award-content');
// 	  function awardequalise($items) {
// 		  var highest = 0;
// 		  $items.each(function(i, el) {
// 			  el.style.height = 'auto';
// 			  var el_height = $(el).height();
// 			  if(el_height > highest) {
// 				  highest = el_height;
// 			  }
// 		  });
// 		  $items.each(function(i, el) {
// 			  el.style.height = (highest+'px');
// 		  });
// 	  }
  
// 	  // Equalise on window load
// 	  $(document).ready(function(){
// 		  equalise($equalise);
// 		  awardequalise($awardise);
// 		  $('.frm_pro_form select').parent().addClass('child-is-select');
// 	  });
  
// 	  // Equalise elements on window resize
// 	  $(window).on('resize', function() {
// 		  equalise($awardise);
// 		  awardequalise($equalise);
// 	  });
  
// 	  // Formidable Forms custom radio/checkboxes
	  $(document).on('click', '.frm_checkbox label input', function() {
		  $(this).parent().toggleClass('check');
	  });
	  $(document).on('click', '.frm_radio label input', function() {
		  $(this).parent().parent().siblings().children('label').removeClass('check');
		  $(this).parent().addClass('check');
	  });
	  // Home logo drop
	  $(window).on('scroll', function() {
		  if ($(window).scrollTop() >= 100) {
			  $('#header').addClass("logo-drop");
		  }
		  if ($(window).scrollTop() <= 50) {
			  $('#header').removeClass("logo-drop");
		  }
	  })
  
	  $(window).on('scroll', function() {
		  if ($(window).scrollTop() >= 300) {
			  $('#header').addClass("scrolled");
		  }
		  if ($(window).scrollTop() <= 100) {
			  $('#header').removeClass("scrolled");
		  }
	  })
	  $('#primary-menu').on('click', function () {
		const $primaryNav = $('#primaryNav');
	
		if (!$primaryNav.hasClass('show')) {
			$('#header').addClass('nav-bg-green');
		} else {
			$('#header').removeClass('nav-bg-green');
		}
	})
  
  
	  // Home page awards
	  $('.award-slider').slick({
		  dots: false,
		  arrows: false,
		  autoplay: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 2,
		  mobileFirst: true,
		  responsive: [
			  {
			  breakpoint: 992,
			  settings: {
				  slidesToShow: 3
				  }
			  }
		  ]
	  });
  
//   });
  
/** Mobile menu script to make submenus opena and close **/

// Wait until the DOM is fully loaded before running the script
document.addEventListener('DOMContentLoaded', function () {
    // Select all links with the class 'toggle-submenu'
    document.querySelectorAll('.toggle-submenu').forEach(link => {
      // Get the closest <li> ancestor (menu item parent)
      const parent = link.closest('li');
      // Find the associated submenu inside this parent
      const submenu = parent.querySelector('.sub-menu');
  
      // If a submenu exists for this link...
      if (submenu) {
        // Add a click event listener to the toggle link
        link.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent the default link behavior (i.e., navigation)
  
          // Toggle the 'show' class on the submenu and store whether it's now visible
          const isOpen = submenu.classList.toggle('show');
  
          // Toggle the 'open' class on the clicked link based on the submenu's state
          this.classList.toggle('open', isOpen);
  
          // Update the aria-expanded attribute for accessibility
          this.setAttribute('aria-expanded', isOpen);
        });
      }
    });
  });
 
